const raFormLayoutLanguageRussian = {
    'ra-form-layout': {
        action: {
            next: 'Далее',
            previous: 'Назад',
        },
    },
};

export default raFormLayoutLanguageRussian;